import { getDevicePermission } from "../base/devices";
import { MEDIA_TYPE } from "../base/media";
import { MiddlewareRegistry } from "../base/redux";
import { SET_RECORDING_ENABLED } from "./actionType";
import "./subscriber";

MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    switch (action.type) {
        case SET_RECORDING_ENABLED:

            if (action.enabled) {
                const permissions = getDevicePermission(getState());
                if ((permissions[MEDIA_TYPE.VIDEO] === false || permissions[MEDIA_TYPE.AUDIO] === false)) {
                    APP.UI.messageHandler.showError({
                        descriptionKey: "카메라, 오디오의 모든 권한이 있어야 녹화가 가능합니다.",
                        titleKey: "녹화 오류"
                    });
                    return;
                } 
            }
    }
    return next(action);
});